import { expr, object } from '@codegrade/utils';
import * as utils from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
function makeLTI1p1Provider(name, { tag = null, 
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
getOverride = () => null, } = {}) {
    const base = Object.freeze({
        tag: (tag ?? name),
        lms: name,
        version: 'lti1.1',
    });
    return Object.freeze({
        ...base,
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        make: (data) => Object.freeze({
            addBorder: false,
            supportsDeadline: false,
            supportsBonusPoints: false,
            supportsStateManagement: false,
            supportsLockDate: data.supportsLockDate,
            supportsAvailableAtManagement: false,
            supportsName: true,
            ...base,
            ...getOverride(),
        }),
    });
}
const blackboardProvider = makeLTI1p1Provider('Blackboard');
const brightSpaceProvider = makeLTI1p1Provider('Brightspace', 
// In the backend we call Brightspace "BrightSpace" (with a capital S)
// so we need to override the tag that is used to identify the correct
// ltiProvider.
{ tag: 'BrightSpace' });
const moodleProvider = makeLTI1p1Provider('Moodle');
const sakaiProvider = makeLTI1p1Provider('Sakai');
const openEdxProvider = makeLTI1p1Provider('Open edX');
const canvasProvider = makeLTI1p1Provider('Canvas', {
    getOverride: () => ({
        addBorder: true,
        supportsDeadline: true,
        supportsBonusPoints: true,
        supportsStateManagement: true,
        supportsAvailableAtManagement: true,
    }),
});
const populiProvider = makeLTI1p1Provider('Populi');
const thoughtIndustriesProvider = makeLTI1p1Provider('Thought Industries', {
    getOverride: () => ({
        addBorder: true,
    }),
});
const defaultLTI1p1Provider = makeLTI1p1Provider('LMS');
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const LTI1p3ProviderNames = Object.freeze([
    'Blackboard',
    'Brightspace',
    'Canvas',
    'Moodle',
    'Revel',
]);
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
class LTI1p3ProviderCapabilties {
    lms;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    addBorder;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    supportsDeadline;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    supportsLockDate;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    supportsBonusPoints;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    supportsStateManagement;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    supportsAvailableAtManagement;
    /** @inheritdoc */
    supportsName;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    version = 'lti1.3';
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(lms, capabilities) {
        this.lms = lms;
        this.addBorder = capabilities.lms === 'Canvas';
        this.supportsDeadline = !capabilities.setDeadline;
        this.supportsBonusPoints = true;
        this.supportsStateManagement = !capabilities.setState;
        this.supportsLockDate = !capabilities.setLockDate;
        this.supportsAvailableAtManagement = !capabilities.setAvailableAt;
        this.supportsName = !capabilities.setName;
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const LTI1p1Providers = [
    blackboardProvider,
    brightSpaceProvider,
    canvasProvider,
    moodleProvider,
    sakaiProvider,
    openEdxProvider,
    populiProvider,
    thoughtIndustriesProvider,
];
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const LTI1p1Lookup = object.mapToObject(LTI1p1Providers, prov => [prov.tag, prov]);
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
function getLti1p1Provider(lms) {
    const prov = LTI1p1Lookup[lms];
    if (prov == null) {
        utils.sentry.withSentry(Sentry => {
            Sentry.captureMessage(`Unknown LTI provider: ${lms}`);
        });
        return defaultLTI1p1Provider;
    }
    else {
        return prov;
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function makeProvider(provider) {
    return expr.match(provider, 'version', {
        'lti1.1': prov => getLti1p1Provider(prov.lms).make({
            supportsLockDate: prov.supportsLockDate,
        }),
        'lti1.3': prov => new LTI1p3ProviderCapabilties(prov.lms, prov.capabilities),
    });
}
